type StatsType =
  | "summary"
  | "dispersion"
  | "percentiles"
  | "outliers"
  | "custom"

interface MetricOutputResultSource {
  result?: Record<string, unknown> | null
}

/**
 * Reads a typed `ResultStats` entry from `MetricOutput.result.stats` by
 * `stats_type` and `name`. Returns undefined when the entry is missing.
 */
export function getStat<T = Record<string, unknown>>(
  mo: MetricOutputResultSource,
  statsType: StatsType,
  name: string,
): T | undefined {
  const stats: unknown = mo.result?.stats
  if (!Array.isArray(stats)) {
    return undefined
  }
  const match = (stats as unknown[]).find(
    (entry): entry is Record<string, unknown> =>
      isRecord(entry) && entry.stats_type === statsType && entry.name === name,
  )
  return match as T | undefined
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}
